/**
 * @description 验证模块
 * @created 2024/04/26 14:22:55
 */

/**
 * @description 判断是否为JSON格式字符串
 * @created 2024/04/26 14:24:04
 */
export function isJson(jsonString) {
  try {
    JSON.parse(jsonString)
    return true
  } catch (error) {
    return false
  }
}

/**
 * @description 判断传入的类型
 * @created 2024/04/26 14:24:11
 */
export function checkType(value) {
  return Object.prototype.toString.call(value).match(/\[object\s(\w+)\]/)[1]
}
